export function scrollToTopOfPage(): void {
  if (typeof window.scrollTo === 'function') {
    window.scrollTo(0, 0);
  }
}
